import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { Appointment } from "models";
import type { REG_VIN_FILTER } from "modules/WarrantyDashboard/hooks";
import type { PAGE_SIZE } from "utils/common";

export type BackordersResponse = {
  items: Appointment[] | null;
  nb_pages: number;
  nb_items: number;
};

export type BackordersDashboardFilters = {
  dealer_ids: number[];
  location_ids: number[];
  page: number;
  search_term: string;
  appointment_date_from: Date | null;
  appointment_date_to: Date | null;
  backorder_date_from: Date | null;
  backorder_date_to: Date | null;
  page_size: PAGE_SIZE;
  reg_vin_filter: REG_VIN_FILTER;
};

const component = "BackordersDashboard";

export const BackordersDashboardQueryKeys = {
  filters: localQueryKey<BackordersDashboardFilters>({ component, data: "filters" }),
  backorders: backendQueryKey<BackordersResponse>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/backorder/list" })
};
